module.exports = __webpack_public_path__ + "img/pic13.44f65006.png";